<template>
    <div>
        <template v-if="config">
            <template v-if="showHongbao">
                <!-- 红包雨 -->
                <div v-if="(typeChild === 31 || (typeChild === 30 && isShowHongbaoRain)) && isShowHongbaoRain" class="hongbao-rain mdl:absolute fixed">
                    <div class="hongbao-rain-bg">
                        <template v-for="(item, index) in showItem?.icon">
                            <div
                                v-for="hongbao in hongbaos[index]"
                                :key="hongbao.id"
                                :style="{
                                    left: `${hongbao.x}px`,
                                    top: `${hongbao.y}px`,
                                    animationName: `fallAndSpin${hongbao.type}`,
                                    animationDuration: `${hongbao.time}s`,
                                    transform: `rotate(${hongbao.angle}deg) scale(${hongbao.scale})`,
                                }"
                                class="hongbao"
                            >
                                <img :src="setSrc(item)" :style="{ width: `${hongbao.size}px` }" alt="1" />
                            </div>
                        </template>
                    </div>
                </div>

                <!-- 左下角固定红包 -->
                <div v-else-if="typeChild === 30 && isShowLeftHongbao && !isCloseHongbao && route.name === 'index'" class="left-bottom-hongbao">
                    <img :src="setSrc(leftIcon)" class="hongbao-image" @click="startHongbaoRain" />
                    <!-- <div class="close-icon" @click="closeRightBottomHongbao">
                        <span class="close-icon-inner">×</span>
                    </div> -->
                </div>
            </template>
        </template>

        <!-- 红包成功弹窗 -->
        <div v-if="showSuccessDialog && showItem?.applyStatus === 0" class="hongbao-dialog-overlay">
            <div class="hongbao-dialog-content" @click.stop>
                <div class="hongbao-envelope">
                    <img :src="setSrc(showItem?.iconBig)" alt="红包" class="envelope-bg" />
                    <div class="info-text" v-html="showItem?.info"></div>
                    <div class="submit-btn" @click="applyHongbao"></div>
                </div>
                <div class="hongbao-dialog-close" @click="closeSuccessDialog">
                    <span class="close-icon-inner">×</span>
                </div>
            </div>
        </div>
        <!-- 红包成功弹窗 -->
        <div v-if="showSuccessDialog && showItem?.applyStatus === 1" class="hongbao-dialog-overlay">
            <div class="hongbao-dialog-content" @click.stop>
                <div class="hongbao-envelope">
                    <img :src="setSrc(showItem?.iconSelected)" alt="红包" class="envelope-bg" />
                    <div class="money-text">
                        <div>
                            <span style="font-size: 25px; color: #613d25">{{ getCurrency() }}</span>
                            <span style="font-size: 40px; color: #da482e">{{ showItem?.money }}</span>
                        </div>
                        <div class="applyTime">{{ t('领取时间') }}:</div>
                        <div class="applyTime">{{ showItem?.finishTime }}</div>
                    </div>
                </div>
                <div class="hongbao-dialog-close" @click="closeSuccessDialog">
                    <span class="close-icon-inner">×</span>
                </div>
            </div>
        </div>
        <!-- 红包规则和时间弹窗 -->
        <div v-if="showRulesDialog" class="hongbao-dialog-overlay hongbao-rules-dialog-overlay" @click="closeRulesDialog">
            <div class="hongbao-dialog-rules-content" @click.stop>
                <div class="hongbao-envelope">
                    <img :src="setSrc(showRuleItem?.contentIcon)" alt="红包" class="envelope-rules-bg" />
                    <div class="money-rules-text">
                        <div class="red-rules-title">
                            <div class="red-rules-title-1">
                                {{
                                    t('最大掉落', {
                                        value: `${getCurrency()}${moneyFormatNoDecimal(showRuleItem?.maxActivityMoney || 0)}`,
                                    })
                                }}
                            </div>
                            <div class="red-rules-title-2">{{ getCurrency() }} {{ moneyFormatNoDecimal(showRuleItem?.maxSendMoney || 0) }}</div>
                        </div>
                        <div class="red-rules-time">
                            <div class="red-rules-time-title">{{ t('每天几次', { value: showRuleItem?.count }) }}</div>
                            <div class="red-rules-time-item" v-for="item in timesList">
                                <img class="red-rules-time-clock" :src="getImg('activity/smactv2_clock.png')" alt="" />
                                <span>{{ item }}</span>
                            </div>
                        </div>
                        <div class="hdialog-rules-titleframe">
                            <div class="hdialog-rules-leftline"></div>
                            <div>{{ t('活动说明') }}</div>
                            <div class="hdialog-rules-rightline"></div>
                        </div>
                        <div class="red-rules-text" v-html="showRuleItem?.info"></div>
                    </div>
                </div>
                <div class="hongbao-dialog-rules-close" @click="closeRulesDialog">
                    <span class="close-icon-inner">×</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { showToast, showDialog, allowMultipleToast } from 'vant';
import useApp from 'core/hooks/useApp';
import agent from 'service/agent';
import useImage from 'core/hooks/useImage';

interface HongBao {
    id: string;
    x: number;
    y: number;
    speed: number;
    angle: number;
    size: number;
    icon: string;
    scale: number;
    time: number;
    type: number;
}

interface RedEnvelope {
    money?: number;
    icon?: string[];
    iconBig?: string;
    iconSelected?: string;
    applyStatus?: number;
    info?: string;
    finishTime?: string;
}

interface RedRuleType {
    times: string;
    maxSendMoney: number;
    contentIcon: string;
    icon: string[];
    count: number;
    maxActivityMoney: number;
    info: string;
}

const { t, appStore, userStore, getCurrency, moneyFormatNoDecimal, showLoadingToast, route, router, showSuccessToast, showFailToast, mitt } = useApp();

const { getImg } = useImage();

const config = computed(() => appStore.getSystemData);
const isLogin = computed(() => userStore.IsLogin);
const showHongbao = computed(() => appStore.showHongbao);

const isShowHongbaoRain = ref(false);
const isShowLeftHongbao = ref(false);
const isCloseHongbao = ref(false);
const hongbaos = ref<{ [key: number | string]: HongBao[] }>({});
const showItem = ref<RedEnvelope>();
const showRuleItem = ref<RedRuleType>();
const typeChild = computed(() => config.value?.red?.typeChild ?? 0);
const icons = computed(() => config.value?.red?.icon ?? []);
const leftIcon = computed(() => config.value?.red?.leftIcon);
const preferentialActivityId = computed(() => config.value?.red?.preferentialActivityId ?? 0);
const timesList = ref([]);
// const rightBottomIcon = computed(() => icons.value[0] || '');

let animationTimer: ReturnType<typeof setInterval> | null = null;
let checkTimer: ReturnType<typeof setInterval> | null = null;

const createHongbao = () => {
    // 获取当前的图标列表
    const currentIcons = icons.value;
    // 随机选择一个图标并固定下来
    const randomIcon = currentIcons.length > 0 ? currentIcons[Math.floor(Math.random() * currentIcons.length)] : '';
    for (let i = 0; i < (showItem.value?.icon?.length || 1); i++) {
        let newArr = [...(hongbaos.value[i] || [])];
        for (let j = 0; j < 5; j++) {
            newArr.push({
                id: `hongbao-${Date.now()}-${Math.random()}`,
                x: Math.random() * window.innerWidth,
                y: -50,
                speed: 2 + Math.random() * 20,
                angle: -30 + Math.random() * 60,
                size: 60 + Math.random() * 10,
                icon: randomIcon,
                scale: 0.2 + Math.random(),
                time: 5 + Math.random() * 5,
                type: 1 + Math.floor(Math.random() * 3),
            });
        }
        hongbaos.value[i] = newArr;
    }
};

const updateHongbaos = () => {
    for (let i = 0; i < (showItem.value?.icon?.length || 1); i++) {
        // 创建一个新的数组来存储更新后的红包
        const updatedHongbaos = hongbaos.value[i]?.filter(hongbao => hongbao.y < window.innerHeight);
        // 更新每个红包的位置
        updatedHongbaos?.forEach(hongbao => {
            hongbao.y += hongbao.speed;
            hongbao.x += Math.sin((hongbao.angle * Math.PI) / 180) * 2;
        });
        // 更新状态
        hongbaos.value[i] = updatedHongbaos;
    }
};

async function startHongbaoRain() {
    const loading = showLoadingToast({
        icon: getLoadingImg(),
        overlay: true,
        className: 'loading-toast',
        forbidClick: true,
        duration: 0,
    });

    try {
        const res = await agent.getPreferentialRedEnvelope({ preferentialActivityId: config.value?.red?.preferentialActivityId });
        console.log('=========点击红包获取信息=========', res);
        loading.close();
        if (res.code === 0) {
            showItem.value = res?.data;
            isShowHongbaoRain.value = true;
            if (animationTimer) clearInterval(animationTimer);
            animationTimer = setInterval(() => {
                updateHongbaos();
                if (Math.random() < 0.2) {
                    createHongbao();
                }
            }, 50);
            showSuccessDialog.value = true;
        }
    } catch (error) {
        loading.close();
        showFailToast(error);
    } finally {
    }
}

// 红包雨规则和时间
async function handleGetRedBonusInfo() {
    const loading = showLoadingToast({
        icon: getLoadingImg(),
        overlay: true,
        className: 'loading-toast',
        forbidClick: true,
        duration: 0,
    });

    try {
        const res = await agent.getPreferentialRedBonusInfo({ preferentialActivityId: config.value?.red?.preferentialActivityId });
        console.log('=========获取红包规则信息=========', res);
        loading.close();
        if (res.code === 0) {
            showRuleItem.value = res?.data;
            showItem.value = {
                icon: res?.data?.icon || [],
            };

            if (animationTimer) clearInterval(animationTimer);
            animationTimer = setInterval(() => {
                updateHongbaos();
                if (Math.random() < 0.2) {
                    createHongbao();
                }
            }, 50);
            showRulesDialog.value = true;
            isShowHongbaoRain.value = true;
            if (showRuleItem.value?.times?.includes(',')) {
                timesList.value = showRuleItem.value?.times?.split(',');
            } else {
                timesList.value = [];
            }
        }
    } catch (error) {
        loading.close();
        showFailToast(error);
    } finally {
    }
}

const stopHongbaoRain = () => {
    console.log('=========停止红包雨=========');
    if (animationTimer) clearInterval(animationTimer);
    isShowHongbaoRain.value = false;
    hongbaos.value = {};
};

const handleHongbaoClick = (hongbao: HongBao) => {
    stopHongbaoRain();
    applyHongbao();
};

const applyHongbao = async () => {
    if (!isLogin.value) {
        return router.push('/login').then(() => {
            stopHongbaoRain();
            showSuccessDialog.value = false;
        });
    }

    stopPeriodicCheck();
    const userinfo = userStore.GetUserInfo;

    allowMultipleToast();

    const loading = showLoadingToast({
        icon: getLoadingImg(),
        overlay: true,
        className: 'loading-toast',
        forbidClick: true,
        duration: 0,
    });

    if (userinfo?.status === 3) {
        // 这里需要实现绑定手机号的逻辑
        // XbCommonUtils.bindPhoneNo(context, deviceWidth, userinfo, bindCallback: () => {
        //   isShowHongbaoRain.value = true;
        // });
        return;
    }

    try {
        const res = await agent.getPreferentialActivityApply({ preferentialActivityId: config.value?.red?.preferentialActivityId });
        console.log('=========领取红包=========', res);
        loading.close();

        const { data, code, msg } = res;
        if (code === 0) {
            showSuccessToast(t('领取成功'));
            // 请求用户信息
            showItem.value.applyStatus = 1;
            showItem.value.money = data?.money || 0;
            showItem.value.finishTime = data?.finishTime;
            await userStore.handleGetUserInfo();
        } else {
            showFailToast(msg);
        }
        // const res = await userStore.applyHongbao({ preferentialActivityId });
        // showApplyHongbaoSuccess(res.money);
    } catch (error) {
        loading.close();
        showFailToast(error);
    } finally {
        const username = userinfo?.username ?? '';
        const cacheKey = `hongbaoRainTime_${preferentialActivityId}_${username}`;
        const now = Math.floor(Date.now() / 1000);
        localStorage.setItem(cacheKey, now.toString());
        startPeriodicCheck();
    }
};

const showSuccessDialog = ref(false);
const showRulesDialog = ref(false);

const closeSuccessDialog = () => {
    showSuccessDialog.value = false;
    stopHongbaoRain();
};

const closeRulesDialog = () => {
    showRulesDialog.value = false;
    stopHongbaoRain();
};

const closeRightBottomHongbao = () => {
    isCloseHongbao.value = true;
};

const checkHongbaoTime = () => {
    console.log('=========轮询检查是否开始红包雨=========', isShowHongbaoRain.value);
    if (!config.value?.red) return;
    // if (typeChild.value === 30) return;
    if (isShowHongbaoRain.value) return;

    const now = Math.floor(Date.now() / 1000);
    const times = config.value.red?.showTimeList || [];
    const username = userStore.GetUserInfo?.username ?? '';
    const cacheKey = `hongbaoRainTime_${preferentialActivityId.value}_${username}`;
    const shouldShowHongbao = times.some(item => now >= item.start && now <= item.end);

    const hongbaoRainTime = parseInt(localStorage.getItem(cacheKey) || '0');
    const isWithin30Minutes = hongbaoRainTime && now - hongbaoRainTime < 30 * 60;

    // console.log('是否在30分钟内:', isWithin30Minutes);
    // console.log('是否在时间段内:', shouldShowHongbao);
    // console.log('当前时间:', now);
    // console.log('开始时间:', times[0]?.start);
    // console.log('结束时间:', times[0]?.end);
    const shouldShowRain = shouldShowHongbao && !isWithin30Minutes;
    if (shouldShowHongbao) {
        isShowLeftHongbao.value = true;
    } else {
        isShowLeftHongbao.value = false;
    }
    if (shouldShowRain && !isShowHongbaoRain.value && isLogin.value) {
        isShowHongbaoRain.value = false;
    } else {
        isShowHongbaoRain.value = false;
    }
};

const startPeriodicCheck = () => {
    clearInterval(checkTimer);
    checkTimer = setInterval(() => {
        checkHongbaoTime();
    }, 5000);
};

const stopPeriodicCheck = () => {
    if (checkTimer) clearInterval(checkTimer);
};

onMounted(() => {
    checkHongbaoTime();
    startPeriodicCheck();

    mitt.on('menuItemClick', (type: string) => {
        console.log('type ---------- ', type);
        if (type === 'red') {
            startHongbaoRain();
        } else if (type === 'redInfo') {
            handleGetRedBonusInfo();
        }
    });
});

onUnmounted(() => {
    if (animationTimer) clearInterval(animationTimer);
    if (checkTimer) clearInterval(checkTimer);
});

const setSrc = (url: string) => {
    return `${config.value?.cdn || ''}${url}`;
};
</script>

<style scoped>
.hongbao-rain {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1001;
}

.hongbao-rain-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
}

.hongbao {
    position: absolute;
    cursor: pointer;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
}

.left-bottom-hongbao {
    position: fixed;
    right: 10px;
    bottom: 72px;
    z-index: 1001;
}

.hongbao-image {
    width: 51px;
    height: 51px;
    cursor: pointer;
    animation: scale 1s ease-in-out infinite alternate;
}

@keyframes scale {
    0% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1.1);
    }
}

.close-icon {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.close-icon-inner {
    color: #fff;
    font-size: 16px;
    line-height: 1;
}

.hongbao-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1002;
}

.hongbao-dialog-content,
.hongbao-dialog-rules-content {
    width: 250px;
    /* 500/2 */
    height: max-content;
    /* 500/2 */
    margin: 0 10px;
    /* 20/2 */
    border-radius: 10px;
    /* 20/2 */
    position: relative;

    &.hongbao-dialog-rules-content {
        width: 300px;
    }

    .hongbao-dialog-close {
        position: absolute;
        bottom: -40px;
        right: 0;
        left: 0;
        margin: 0 auto;
        width: 30px;
        height: 30px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .close-icon-inner {
            color: #fff;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 2px;
        }
    }

    .hongbao-dialog-rules-close {
        position: absolute;
        top: 40px;
        right: 10px;
        width: 25px;
        height: 25px;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .close-icon-inner {
            color: #000;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 2px;
        }
    }
}

.hongbao-envelope {
    width: 100%;
    position: relative;

    .info-text {
        position: absolute;
        top: 20px;
        /* 40/2 */
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        /* 300/2 */
        padding: 15px;
        min-height: 50px;
        /* 300/2 */
        height: max-content;
        min-height: 100px;
    }

    .submit-btn {
        position: absolute;
        bottom: 35px;
        left: 0;
        right: 0;
        margin: auto;
        width: 65px;
        height: 65px;
        border-radius: 50%;
    }
}

.envelope-bg,
.envelope-rules-bg {
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    object-fit: fill;

    &.envelope-rules-bg {
        width: 300px;
    }
}

.money-text,
.money-rules-text {
    position: absolute;
    top: 25px;
    /* 40/2 */
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    /* 300/2 */
    padding: 15px;
    min-height: 50px;
    /* 300/2 */
    height: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-align: center;
    white-space: normal;
    word-break: break-word;

    &.money-rules-text {
        padding-top: 75px;
        align-items: flex-start;
        margin: unset;
    }

    .red-rules-title {
        height: 90px;
        width: 100%;
        padding: 10px 15px;
        font-family: 'HelveticaNeue';
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .red-rules-title-1 {
            color: #fff;
            font-size: 14px;
            margin-bottom: 15px;
        }

        .red-rules-title-2 {
            color: rgb(255, 203, 16);
            font-size: 30px;
        }
    }

    .red-rules-time {
        background: linear-gradient(90deg, rgb(252, 227, 65) 0%, rgb(253, 246, 99) 100%);
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        width: 230px;
        margin: auto;
        padding: 10px 10px 0;

        .red-rules-time-title {
            width: 100%;
            font-size: 16px;
            font-family: 'HelveticaNeue';
            color: rgb(18, 21, 12);
            text-transform: uppercase;
            text-align: center;
            margin-bottom: 10px;
            font-weight: 900;
        }

        .red-rules-time-item {
            width: 100px;
            font-size: 12px;
            font-family: 'PingFang';
            color: rgb(19, 21, 12);
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 10px;

            .red-rules-time-clock {
                width: 12px;
                height: 12px;
                margin-right: 5px;
            }
        }
    }

    .hdialog-rules-titleframe {
        position: relative;
        margin-top: 15px;
        margin-bottom: 15px;
        left: 0;
        width: 100%;
        color: rgba(255, 255, 255, 0.85);
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .hdialog-rules-leftline {
        background-image: linear-gradient(90deg, rgba(249, 244, 120, 0) 0%, rgba(249, 244, 120, 0.65) 100%);
        border-radius: 1px;
        width: 40px;
        height: 2px;
        margin-right: 8px;
    }

    .hdialog-rules-rightline {
        transform: scaleX(-1);
        background-image: linear-gradient(90deg, rgba(249, 244, 120, 0) 0%, rgba(249, 244, 120, 0.65) 100%);
        border-radius: 1px;
        width: 40px;
        height: 2px;
        margin-left: 8px;
    }

    .red-rules-text {
        width: 100%;
        text-align: left;
        font-size: 13px;
        line-height: 15px;
        font-weight: normal;
    }

    .applyTime {
        color: #613d25;
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
    }
}
</style>
